import MetricAndUpDown from "@/pages/dashboard/components/MetricAndUpDown";
import { getVal } from "@/pages/dashboard/pages/comparison/_config/utils";
import { useWeekDayArr } from "@/pages/dashboard/utils/customHook";
import { getMonetUnit } from "@/pages/dashboard/utils/moneyUnit";
import { formatNum, getDynamicLocalCnEnText, getUpAndDownStatus, getWeekDay } from "@/pages/dashboard/utils/utils";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { getLocale, useIntl, useSelector } from "umi";
import { ACCUMULATED_DEFAULT_VALUE } from "@/pages/dashboard/components/Accumulate";
import { getCountryFlag } from "@/pages/home/_config/countries";
import { getExplainVal } from "@/pages/dashboard/utils/getExplainVal";
import SvgIcon from "@/pages/home/components/SvgIcon";
import { Bubble } from "tea-component";
import { IExplain } from "@/pages/dashboard/types/dashboard";

export const useMetrics = (timeType: string) => {

  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    if (timeType === 'Day') {
      return [
        {
          id: 'total_mtx_revenue',
          indicatorsName: 'total_mtx_revenue',
          resName: 'total_mtx_revenue',
          chWidth: 190,
          enWidth: 310,
          chPercentWidth: 270,
          enPercentWidth: 310,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Rev',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_revenue'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'total_mtx_payers',
          indicatorsName: 'total_mtx_payers',
          resName: 'total_mtx_payers',
          chWidth: 200,
          enWidth: 270,
          chPercentWidth: 200,
          enPercentWidth: 300,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Payer',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_payers'
          }),
          avgName: '',

          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        }, // 非用户类，保留两位小数，bmk保留两位小数

        {
          id: 'total_mtx_payer_rate',
          indicatorsName: 'total_mtx_payer_rate',
          resName: 'total_mtx_payer_rate',
          chWidth: 200,
          enWidth: 300,
          chPercentWidth: 200,
          enPercentWidth: 300,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Payer%',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_payer_rate'
          }),
          avgName: '',

          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        }, // 用户类 ，bmk保留两位小数
        {
          id: 'mtx_revenue',
          indicatorsName: 'mtx_revenue',
          resName: 'mtx_revenue',
          resAvgName: '',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          name: formatMessage({
            id: 'pc_console_revenue_mtx_revenue'
          }),
          avgName: '',
          rainbowKey: 'Pc In-Game Revenue',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'active_users',
          indicatorsName: 'active_users',
          resName: 'active_users',
          chWidth: 180,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({ id: 'overview_daily_DAU' }),
          rainbowKey: 'DAU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'mtx_arpu',
          indicatorsName: 'mtx_arpu',
          resName: 'mtx_arpu',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_arpu'
          }),
          rainbowKey: 'Pc In-Game ARPU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_arppu',
          indicatorsName: 'mtx_arppu',
          resName: 'mtx_arppu',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_arppu'
          }),
          rainbowKey: 'Pc In-Game ARPPU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_payers',
          resName: 'mtx_payers',
          indicatorsName: 'mtx_payers',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_payers'
          }),
          rainbowKey: 'Pc In-Game Payer',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'mtx_payer_rate',
          resName: 'mtx_payer_rate',
          indicatorsName: 'mtx_payer_rate',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          rainbowKey: 'Pc In-Game Payer%',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_payer_rate'
          }),
          avgName: '',
          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'new_user_mtx_payer_rate',
          resName: 'new_user_mtx_payer_rate',
          indicatorsName: 'new_user_mtx_payer_rate',
          chWidth: 270,
          enWidth: 300,
          chPercentWidth: 270,
          enPercentWidth: 330,
          resAvgName: '',
          rainbowKey: 'MTX Payer%(New Users)',
          name: formatMessage({
            id: 'pc_console_revenue_new_user_mtx_payer_rate'
          }),
          avgName: '',
          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_new_paid_users',
          resName: 'mtx_new_paid_users',
          indicatorsName: 'mtx_new_paid_users',
          chWidth: 200,
          enWidth: 280,
          chPercentWidth: 200,
          enPercentWidth: 280,
          resAvgName: '',
          rainbowKey: 'First-time MTX Payer',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_paid_users'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'mtx_new_pay_amount',
          resName: 'mtx_new_pay_amount',
          indicatorsName: 'mtx_new_pay_amount',
          chWidth: 220,
          enWidth: 320,
          chPercentWidth: 220,
          enPercentWidth: 320,
          resAvgName: '',
          rainbowKey: 'Rev(First-time MTX Payer)',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_pay_amount'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'mtx_new_arpu',
          resName: 'mtx_new_arpu',
          indicatorsName: 'mtx_new_arpu',
          chWidth: 260,
          enWidth: 340,
          chPercentWidth: 260,
          enPercentWidth: 340,
          resAvgName: '',
          rainbowKey: 'First-time MTX Payer ARPU',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_arpu'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'new_user_arpu',
          resName: 'new_user_arpu',
          indicatorsName: 'new_user_arpu',
          chWidth: 260,
          enWidth: 210,
          chPercentWidth: 260,
          enPercentWidth: 210,
          resAvgName: '',
          rainbowKey: 'New User ARPU',
          name: formatMessage({
            id: 'pc_console_revenue_new_user_arpu'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'total_pay_days',
          resName: 'total_pay_days',
          indicatorsName: 'total_pay_days',
          chWidth: 230,
          enWidth: 200,
          chPercentWidth: 230,
          enPercentWidth: 200,
          resAvgName: '',
          rainbowKey: 'Total Pay Days',
          name: formatMessage({
            id: 'pc_console_revenue_total_pay_days'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: '30d_ltv',
          resName: '30d_ltv',
          indicatorsName: '30d_ltv',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          rainbowKey: 'MTX LTV30',
          name: formatMessage({
            id: 'pc_console_revenue_30d_ltv'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: '180d_ltv',
          resName: '180d_ltv',
          indicatorsName: '180d_ltv',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          rainbowKey: 'MTX LTV180',
          name: formatMessage({
            id: 'pc_console_revenue_180d_ltv'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'avg_time_to_purchase',
          resName: 'avg_time_to_purchase',
          indicatorsName: 'avg_time_to_purchase',
          chWidth: 230,
          enWidth: 250,
          chPercentWidth: 230,
          enPercentWidth: 250,
          resAvgName: '',
          rainbowKey: 'Time to Purchase (days)',
          name: formatMessage({
            id: 'pc_overview_Time_to_Purchase'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
      ];
    }

    if (timeType === 'Week') {
      return [
        {
          id: 'total_mtx_revenue',
          indicatorsName: 'total_mtx_revenue',
          resName: 'total_mtx_revenue',
          chWidth: 190,
          enWidth: 310,
          chPercentWidth: 270,
          enPercentWidth: 310,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Rev',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_revenue'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'total_mtx_payers',
          indicatorsName: 'total_mtx_payers',
          resName: 'total_mtx_payers',
          chWidth: 200,
          enWidth: 270,
          chPercentWidth: 200,
          enPercentWidth: 300,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Payer',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_payers'
          }),
          avgName: '',

          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        }, // 非用户类，保留两位小数，bmk保留两位小数

        {
          id: 'total_mtx_payer_rate',
          indicatorsName: 'total_mtx_payer_rate',
          resName: 'total_mtx_payer_rate',
          chWidth: 200,
          enWidth: 300,
          chPercentWidth: 200,
          enPercentWidth: 300,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Payer%',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_payer_rate'
          }),
          avgName: '',

          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        }, // 用户类 ，bmk保留两位小数
        {
          id: 'mtx_revenue',
          indicatorsName: 'mtx_revenue',
          resName: 'mtx_revenue',
          resAvgName: '',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          name: formatMessage({
            id: 'pc_console_revenue_mtx_revenue'
          }),
          avgName: '',
          rainbowKey: 'Pc In-Game Revenue',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'active_users',
          indicatorsName: 'active_users',
          resName: 'active_users',
          chWidth: 180,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({ id: 'overview_weekly_WAU' }),
          rainbowKey: 'WAU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'mtx_arpu',
          indicatorsName: 'mtx_arpu',
          resName: 'mtx_arpu',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_arpu'
          }),
          rainbowKey: 'Pc In-Game ARPU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_arppu',
          indicatorsName: 'mtx_arppu',
          resName: 'mtx_arppu',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_arppu'
          }, { unit: getMonetUnit() }),
          rainbowKey: 'Pc In-Game ARPPU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_payers',
          resName: 'mtx_payers',
          indicatorsName: 'mtx_payers',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_payers'
          }),
          rainbowKey: 'Pc In-Game Payer',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'mtx_payer_rate',
          resName: 'mtx_payer_rate',
          indicatorsName: 'mtx_payer_rate',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_payer_rate'
          }),
          rainbowKey: 'Pc In-Game Payer%',
          avgName: '',
          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'new_user_mtx_payer_rate',
          resName: 'new_user_mtx_payer_rate',
          indicatorsName: 'new_user_mtx_payer_rate',
          chWidth: 270,
          enWidth: 300,
          chPercentWidth: 270,
          enPercentWidth: 330,
          resAvgName: '',
          rainbowKey: 'MTX Payer%(New Users)',
          name: formatMessage({
            id: 'pc_console_revenue_new_user_mtx_payer_rate'
          }),
          avgName: '',
          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_new_paid_users',
          resName: 'mtx_new_paid_users',
          indicatorsName: 'mtx_new_paid_users',
          chWidth: 200,
          enWidth: 280,
          chPercentWidth: 200,
          enPercentWidth: 280,
          resAvgName: '',
          rainbowKey: 'First-time MTX Payer',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_paid_users'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'mtx_new_pay_amount',
          resName: 'mtx_new_pay_amount',
          indicatorsName: 'mtx_new_pay_amount',
          chWidth: 220,
          enWidth: 320,
          chPercentWidth: 220,
          enPercentWidth: 320,
          resAvgName: '',
          rainbowKey: 'Rev(First-time MTX Payer)',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_pay_amount'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'mtx_new_arpu',
          resName: 'mtx_new_arpu',
          indicatorsName: 'mtx_new_arpu',
          chWidth: 260,
          enWidth: 340,
          chPercentWidth: 260,
          enPercentWidth: 340,
          resAvgName: '',
          rainbowKey: 'First-time MTX Payer ARPU',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_arpu'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'new_user_arpu',
          resName: 'new_user_arpu',
          indicatorsName: 'new_user_arpu',
          chWidth: 260,
          enWidth: 210,
          chPercentWidth: 260,
          enPercentWidth: 210,
          resAvgName: '',
          rainbowKey: 'New User ARPU',
          name: formatMessage({
            id: 'pc_console_revenue_new_user_arpu'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

      ];
    }

    if (timeType === 'Month') {
      return [
        {
          id: 'total_mtx_revenue',
          indicatorsName: 'total_mtx_revenue',
          resName: 'total_mtx_revenue',
          chWidth: 190,
          enWidth: 310,
          chPercentWidth: 270,
          enPercentWidth: 310,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Rev',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_revenue'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'total_mtx_payers',
          indicatorsName: 'total_mtx_payers',
          resName: 'total_mtx_payers',
          chWidth: 200,
          enWidth: 270,
          chPercentWidth: 200,
          enPercentWidth: 300,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Payer',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_payers'
          }),
          avgName: '',

          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        }, // 非用户类，保留两位小数，bmk保留两位小数

        {
          id: 'total_mtx_payer_rate',
          indicatorsName: 'total_mtx_payer_rate',
          resName: 'total_mtx_payer_rate',
          chWidth: 200,
          enWidth: 300,
          chPercentWidth: 200,
          enPercentWidth: 300,
          resAvgName: '',
          rainbowKey: 'Accumulate MTX Payer%',
          name: formatMessage({
            id: 'pc_console_revenue_total_mtx_payer_rate'
          }),
          avgName: '',

          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        }, // 用户类 ，bmk保留两位小数
        {
          id: 'mtx_revenue',
          indicatorsName: 'mtx_revenue',
          resName: 'mtx_revenue',
          resAvgName: '',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          name: formatMessage({
            id: 'pc_console_revenue_mtx_revenue'
          }),
          avgName: '',
          rainbowKey: 'Pc In-Game Revenue',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'active_users',
          indicatorsName: 'active_users',
          resName: 'active_users',
          chWidth: 180,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({ id: 'overview_monthly_MAU' }),
          rainbowKey: 'MAU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },

        {
          id: 'mtx_arpu',
          indicatorsName: 'mtx_arpu',
          resName: 'mtx_arpu',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_arpu'
          }),
          rainbowKey: 'Pc In-Game ARPU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_arppu',
          indicatorsName: 'mtx_arppu',
          resName: 'mtx_arppu',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_arppu'
          }, { unit: getMonetUnit() }),
          rainbowKey: 'Pc In-Game ARPPU',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_payers',
          resName: 'mtx_payers',
          indicatorsName: 'mtx_payers',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_payers'
          }),
          rainbowKey: 'Pc In-Game Payer',
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'mtx_payer_rate',
          resName: 'mtx_payer_rate',
          indicatorsName: 'mtx_payer_rate',
          chWidth: 200,
          enWidth: 200,
          chPercentWidth: 200,
          enPercentWidth: 200,
          resAvgName: '',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_payer_rate'
          }),
          rainbowKey: 'Pc In-Game Payer%',
          avgName: '',
          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'new_user_mtx_payer_rate',
          resName: 'new_user_mtx_payer_rate',
          indicatorsName: 'new_user_mtx_payer_rate',
          chWidth: 270,
          enWidth: 300,
          chPercentWidth: 270,
          enPercentWidth: 330,
          resAvgName: '',
          rainbowKey: 'MTX Payer%(New Users)',
          name: formatMessage({
            id: 'pc_console_revenue_new_user_mtx_payer_rate'
          }),
          avgName: '',
          isPercent: true,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'mtx_new_paid_users',
          resName: 'mtx_new_paid_users',
          indicatorsName: 'mtx_new_paid_users',
          chWidth: 200,
          enWidth: 280,
          chPercentWidth: 200,
          enPercentWidth: 280,
          resAvgName: '',
          rainbowKey: 'First-time MTX Payer',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_paid_users'
          }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: true,
          dodDecimals: 1
        },
        {
          id: 'mtx_new_pay_amount',
          resName: 'mtx_new_pay_amount',
          indicatorsName: 'mtx_new_pay_amount',
          chWidth: 220,
          enWidth: 320,
          chPercentWidth: 220,
          enPercentWidth: 320,
          resAvgName: '',
          rainbowKey: 'Rev(First-time MTX Payer)',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_pay_amount'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },
        {
          id: 'mtx_new_arpu',
          resName: 'mtx_new_arpu',
          indicatorsName: 'mtx_new_arpu',
          chWidth: 260,
          enWidth: 340,
          chPercentWidth: 260,
          enPercentWidth: 340,
          resAvgName: '',
          rainbowKey: 'First-time MTX Payer ARPU',
          name: formatMessage({
            id: 'pc_console_revenue_mtx_new_arpu'
          }, { unit: getMonetUnit() }),
          avgName: '',

          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

        {
          id: 'new_user_arpu',
          resName: 'new_user_arpu',
          indicatorsName: 'new_user_arpu',
          chWidth: 260,
          enWidth: 210,
          chPercentWidth: 260,
          enPercentWidth: 210,
          resAvgName: '',
          rainbowKey: 'New User ARPU',
          name: formatMessage({
            id: 'pc_console_revenue_new_user_arpu'
          }, { unit: getMonetUnit() }),
          avgName: '',
          isPercent: false,
          decimals: 1,
          isUserType: false,
          dodDecimals: 1
        },

      ];
    }

  }, [getLocale(), timeType]);
  return result;
};

export const useFunctionWithIntl = (localText, timeType = 'Day') => {
  const { selector } = useSelector(state => state?.dashboardSetting ?? {});
  const weekDayArr = useWeekDayArr();
  const { formatMessage } = useIntl();


  const DATE_COLUMN = {
    key: 'date',
    header: localText.date,
    width: 170,
    fixed: "left",
    align: "left",
    render(record: any) {
      /** Sum提示需要用到useState，
      *所以拿出来单独处理，
      *不然render里拿不到最新的的state
      */
      return <DateCell record={record} formatMessage={formatMessage} weekDayArr={weekDayArr} />;
    }
  };

  // 日期列, 周六日的颜色高亮 & Sum行增加提示
  function DateCell({ record, formatMessage, weekDayArr }) {
    const [isIconHover, setIsIconHover] = useState(false);
    const weekDay = getWeekDay(record.date, weekDayArr)?.slice(1, -1);
    const locale = getLocale();

    const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
    const showSumTip = record.date === 'Sum' || record.date === '汇总值';
    const displayDate = moment(record.date).isValid() === true ?
      (timeType === "Month" ? moment(record.date).format("YYYY-MM") : moment(record.date).format("YYYY-MM-DD")) : record.date;
    return (
      <div style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
        <span className='table-text'>{displayDate}</span>
        {timeType === 'Month' ? <span style={{ display: 'inline-block', width: '0.4em' }}></span> :
          <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>
        }
        {showSumTip && (
          <div className='port-item'>
            <div onMouseOver={() => { setIsIconHover(true) }} onMouseOut={() => { setIsIconHover(false) }} >
              <Bubble
                dark
                placement="top-start"
                arrowPointAtCenter
                style={{ maxWidth: locale === 'en-US' ? '235px' : '253px' }}
                content={formatMessage({ id: 'overview_sum_tip' })}
              >
                <div><SvgIcon className='port-icon' type={isIconHover ? 'alert-circle-action' : 'alert-circle-m'} /></div>
              </Bubble>
            </div>
          </div>
        )}
      </div>
    );
  }


  // 获取维度列定义配置
  const getAccumulateColumns = (accumulates: string[] = [], gameCode: string, segmentValue: string) => {
    if (accumulates[0] === ACCUMULATED_DEFAULT_VALUE) return [];
    return accumulates?.filter(v => v !== 'date')?.map((value) => ({
      key: value + segmentValue,
      copyKey: value,
      header: localText[value],
      width: 200,
      align: 'left',
      render(record: { [x: string]: any; country: string; }) {
        let ImgDom: JSX.Element;
        try {
          ImgDom = <img style={{ width: '24px', height: '16px', marginRight: '8px', verticalAlign: 'middle' }} src={getCountryFlag(record.country)} alt="flag" />;
        } catch (error) {
          ImgDom = <img style={{ width: '24px', height: '16px', marginRight: '8px', verticalAlign: 'middle' }} src={getCountryFlag('undefined')} alt="flag" />;
        }
        return (<>
          {
            record[value] ? (<div>
              {value == 'country' && ImgDom}
              <span>{getDynamicLocalCnEnText(value, record[value], gameCode, getLocale(), selector)}</span>
            </div>) : "-"
          }
        </>

        );
      }
    }));
  };
  const isEn = getLocale() === 'en-US';
  // 获取国家对比页面 指标列和指标对比列
  const getMetricColumns = (metricsValue = [], metricsObj: { [x: string]: any; }, explainInfo: IExplain, showType: string) => {
    const isHideUpDown = showType === "value_only";
    return metricsValue.reduce((columns: any, value) => {
      const obj = metricsObj[value];
      const { rainbowKey, explainEn, explainCn } = obj || {};
      
      const explain = getExplainVal(explainInfo, rainbowKey, getLocale(), explainEn, explainCn);
      let width = 230;
      if (isEn) {
        width = isHideUpDown ? obj?.enWidth : obj?.enPercentWidth;
      } else {
        width = isHideUpDown ? obj?.chWidth : obj?.chPercentWidth;
      }
      columns.push(
        {
          key: obj?.resName + showType,
          copyKey: obj?.resName,
          header: obj?.name,
          align: "right",
          explain,
          width,
          isPercent: obj?.isPercent,
          render(record: { metrics: { [x: string]: {}; }; type: any; }) {
            const data = record?.metrics?.[obj?.resName] || {};
            const isShowChange = showType !== "value_only";
            // record.type 有值的时候, 说明是汇总行, 指标列的状态是no
            return metricRender(data?.value, data?.[showType.replace("show_", "")], obj, record.type, isShowChange);
          }
        },
      );
      return columns;
    }, []);
  };

  return {
    DATE_COLUMN,
    getAccumulateColumns,
    getMetricColumns
  };
};

export function metricRender(
  value: number,
  percent: any,
  metric: { isPercent: any; },
  type: string,
  isShowUpdown: boolean
) {
  const percentWidth = metric?.isPercent && type !== 'count' ? (value > 1 ? 100 : value * 100) : 0;
  const status = getUpAndDownStatus(percent, !!type);

  const percentStr = !!type ? '' : getVal(metric, percent, true);
  const formatValue = type === 'count' ? formatNum(value, false, true) : getVal(metric, value, false);
  return (<>
    <div className={"table-text-bg"} style={{ width: `${percentWidth}%` }} />
    <MetricAndUpDown
      metric={formatValue}
      updown={isShowUpdown ? { data: percentStr, status } : null}
      hasTooltip={false}
    />
  </>);

}